import { refreshScheduler } from './scheduler';
import { FILTERS_UPDATE } from '../../constants/types';

function updateFilters(filter) {
  return {
    type: FILTERS_UPDATE,
    filter,
  };
}

function updateFiltersAndRefresh(filters) {
  return dispatch => {
    dispatch(updateFilters(filters));
    dispatch(refreshScheduler());
  };
}

export { updateFilters, updateFiltersAndRefresh };
